<template>
  <div class="card-lists">
    <div class="card-list_content">
      <div class="card-lists__content">
        <div class="mg_10" v-if="isShowReceivingCodeComp">
          <!-- 收件码 -->
          <ReceivingCode :info="receivedCode" />
        </div>
        <div class="mg_10" v-if="orderDesc.title">          
          <!-- 订单说明 -->
          <ShareOrderInfo :info="orderDesc" />
        </div>
        <div class="mg_10">
          <!-- 骑手信息 -->
          <ServerCard
            :orderId="orderId"
            :data="riderInfo"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ServerCard from '@/components/OrderDetailShareCard/serverCard'
import ReceivingCode from '@/components/EntregaShare/ReceivingCode';
import ShareOrderInfo from '@/components/EntregaShare/ShareOrderInfo';
import { ORDER_STATUS } from '@/const/entrega';

export default {
  name: 'OrderDetailShareCard',
  components: {
    ServerCard,
    ReceivingCode,
    ShareOrderInfo,
  },
  computed: {
    ...mapState({
      receivedCode: ({ entrega }) => entrega.receivedCode,
      orderDesc: ({ entrega }) => entrega.orderDesc,
      orderData: ({ entrega }) => entrega.orderData,
      riderInfo: ({ entrega }) => entrega.riderInfo,
      orderStatus: ({ entrega }) => entrega.orderStatus,
    }),
    // 收件码组件展示逻辑
    isShowReceivingCodeComp() {
      let tag = false;
      if (
        (this.orderStatus === ORDER_STATUS.FLASH_D_TAKEN || this.orderStatus === ORDER_STATUS.FLASH_D_ARRIVED_DESTINATION) && this.receivedCode?.code
      ) {
          tag = true
      }
      return tag
    },
  },
  props: {
    orderId: String,
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.card-lists {
  padding: rem(20) 0 120px;
}
.animation-height {
  height: 0 !important;
  width: 0 !important;
}
.position-top {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  padding: 0 rem(28);
}
.animation-order-status {
  @extend .position-top;
  opacity: 0;
}
.position-top-padding {
  padding-top: rem(128);
}
.mg_10 {
  margin-bottom: rem(20);
}

.order-status__desc {
  height: rem(128);
  line-height: rem(128);
  padding-right: rem(40);
  font-size: rem(40);

  i {
    font-size: rem(28);
  }
}

.card-list_content {
  margin: 0 rem(28);
  // height: 100vh;
}

.star-card {
  border-radius: rem(12);
  font-size: rem(32);
  padding: rem(40) rem(20);
  .star-title {
    margin-bottom: rem(40);
  }
}
</style>
